module.exports = __webpack_public_path__ + "static/12-18c911bcb11d9ee8208388644b0989ce.jpg";